import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { size } from '@twistopayments/design-system/styles'

export const aprBlock = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${size[12]};
`

export const title = (theme: Theme) => css`
  color: ${theme.palette.text.description};
  font-weight: 500;
`

export const content = (theme: Theme) => css`
  color: ${theme.palette.text.caption};
`

export const divider = (theme: Theme) => css`
  border-top: 1px solid ${theme.palette.tertiary.mediumContrast};
  padding-top: ${size[24]};
`
